'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterSection = exports.BORDER_ELEMENT = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShopifySection2 = require('./../ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Elements
var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-footer]'; /*
                                                                        *  Footer Section
                                                                        *    Provides scripts for elements within the Footer section.
                                                                        *
                                                                        *  Version:
                                                                        *    1.0.0 - 2020/07/11
                                                                        */

var BORDER_ELEMENT = exports.BORDER_ELEMENT = '[data-footer-border]';

var FooterSection = exports.FooterSection = function (_ShopifySection) {
  (0, _inherits3.default)(FooterSection, _ShopifySection);

  function FooterSection(container) {
    (0, _classCallCheck3.default)(this, FooterSection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FooterSection.__proto__ || Object.getPrototypeOf(FooterSection)).call(this, container));

    _this.footerBorder = container.find(BORDER_ELEMENT);

    $(window).on('scroll', function () {
      return _this.onScroll();
    });
    return _this;
  }

  (0, _createClass3.default)(FooterSection, [{
    key: 'onScroll',
    value: function onScroll() {
      var top = $(window).scrollTop();
      // let height
      this.footerBorder.css('background-position', parseInt(top / 5) + '% 0%');
    }
  }]);
  return FooterSection;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, FooterSection);